/**
 * A single frozen empty array, for `?? EMPTY` fallbacks.
 *
 * `x ?? []` looks harmless and is not: the literal is a NEW array on every
 * evaluation, so anything comparing references sees a change that never
 * happened. Two places that compare references:
 *
 * * a hook dependency list — `useEffect(…, [rows])` re-runs on every render
 *   while the data is still loading, rather than when the rows arrive;
 * * a **zustand selector**. Zustand 5 applies the selector inside
 *   `useSyncExternalStore`'s `getSnapshot`, and React treats a snapshot that
 *   differs between two calls in the same render as a store that will not
 *   settle — "The result of getSnapshot should be cached to avoid an infinite
 *   loop".
 *
 * Frozen so a caller cannot push into the shared instance and hand every other
 * caller its element.
 *
 * Only for a fallback that is immediately read. A value the caller may want to
 * *replace* wants its own array.
 */
export const EMPTY: readonly never[] = Object.freeze([]);
